import React from "react";
import { Phone, Mail, MapPin, MessageCircle, Building2, Clock } from "lucide-react";
import { ContentPage, Section } from "../../components/ContentPage";
import { BRAND } from "../../data/site";

export default function Kontakt() {
  return (
    <ContentPage
      testid="page-kontakt"
      eyebrow="Kontakt"
      title={<>Napisz do nas <span className="text-coral">dyskretnie.</span></>}
      lead="Masz pytania o współpracę, szkolenia lub ofertę dla agencji? Odezwij się — odpowiadamy szybko, dyskretnie i bez zobowiązań. Współpraca wyłącznie 18+."
      seo={{
        title: "Kontakt — PMPOINT SP. Z O.O. | Warszawa",
        description: "Skontaktuj się z PMPOINT: telefon 571 309 237, WhatsApp, e-mail kontakt@pmpoint.pl. PMPOINT SP. Z O.O., ul. Marcina Kasprzaka 31/119, 01-234 Warszawa, NIP 6312696842.",
        canonical: "https://pmpoint.pl/kontakt",
      }}
    >
      <div className="grid lg:grid-cols-2 gap-8">
        <Section title="Dane kontaktowe" className="mb-0">
          <ul className="space-y-5">
            <li className="flex items-start gap-3">
              <span className="mt-0.5 text-coral"><Phone size={20} /></span>
              <div>
                <div className="text-xs uppercase tracking-[0.14em] text-white/40 mb-1">Telefon / WhatsApp</div>
                <a href={`tel:+${BRAND.phoneIntl}`} className="text-white font-semibold hover:text-coral transition-colors" data-testid="kontakt-phone">{BRAND.phone}</a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-0.5 text-coral"><Mail size={20} /></span>
              <div>
                <div className="text-xs uppercase tracking-[0.14em] text-white/40 mb-1">E-mail</div>
                <a href={`mailto:${BRAND.email}`} className="text-white font-semibold hover:text-coral transition-colors" data-testid="kontakt-email">{BRAND.email}</a>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-0.5 text-coral"><MapPin size={20} /></span>
              <div>
                <div className="text-xs uppercase tracking-[0.14em] text-white/40 mb-1">Adres</div>
                <span className="text-white/85">{BRAND.address}</span>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-0.5 text-coral"><Building2 size={20} /></span>
              <div>
                <div className="text-xs uppercase tracking-[0.14em] text-white/40 mb-1">Dane firmy</div>
                <span className="text-white/85">{BRAND.legalName} · NIP {BRAND.nip}</span>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <span className="mt-0.5 text-coral"><Clock size={20} /></span>
              <div>
                <div className="text-xs uppercase tracking-[0.14em] text-white/40 mb-1">Czas odpowiedzi</div>
                <span className="text-white/85">Zwykle w ciągu 24 godzin</span>
              </div>
            </li>
          </ul>
        </Section>

        <Section title="Najszybciej" className="mb-0">
          <div className="pm-card p-8">
            <p className="text-white/70 mb-6">
              Wolisz od razu porozmawiać? Napisz na WhatsApp lub wypełnij formularz zgłoszeniowy na stronie głównej.
            </p>
            <a
              href={BRAND.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="kontakt-whatsapp"
              className="w-full mb-3 inline-flex items-center justify-center gap-2 h-12 rounded-lg bg-[#25D366] text-white font-bold hover:bg-[#1EBE5D] transition-colors"
            >
              <MessageCircle size={18} /> Napisz na WhatsApp
            </a>
            <a
              href="/#aplikuj"
              data-testid="kontakt-apply"
              className="w-full inline-flex items-center justify-center h-12 rounded-lg bg-white/5 border border-white/20 text-white font-semibold hover:border-coral hover:text-coral transition-colors"
            >
              Wypełnij formularz zgłoszeniowy
            </a>
          </div>
        </Section>
      </div>
    </ContentPage>
  );
}
